import {html} from 'lit-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {classMap} from 'lit-html/directives/class-map';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import {repeat} from 'lit-html/directives/repeat';

import TemplateRegistry from '../template/template-registry';
import {optionClassMap} from '../template/template-util.js';
import Upload from '../upload/upload';

TemplateRegistry.templates['upload'] = (option, config, onChange, onErrorClear, getOption) => {

    // get or create upload controller
    option._controller = option._controller || Upload.getInstance().controller(option, config.product, config.productForm, getOption);
    // NEW: always update (before !init - which called it on all renders expect first)
    option._controller.update(option, config.productForm, config.productFormLink);

    // REMOVED: <input type="file" id="${option.id}" attribute (to avoid opening file dialog on label click)

    return html`  
        <div class="cl-po--upload ${classMap(optionClassMap(option))}">
            <div class="cl-po--upload-wrap">
                <label class="cl-po--input cl-po--upload-button">
                 <input type="file" @change=${(e) => option._controller.onChange(e, option, config.productForm, config.productFormLink, onChange)} 
                     ?multiple=${option.params.multiple}  accept=${ifDefined(option.params.accept)} >
                 <span>${unsafeHTML(option.params.button || 'Choose file')}</span>
                </label>
                ${option.value && option._layer && option._layer.params.crop ? html`
                    <label class="cl-po--input cl-po--upload-button crop ${classMap({'has-label': option._layer.params.cropLabel})}" @click=${e => option._controller.crop(option,config.productForm)}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"><path fill="currentColor" d="M15 17v2H6a1 1 0 0 1-1-1V7H2V5h3V2h2v15h8zm2 5V7H9V5h9a1 1 0 0 1 1 1v11h3v2h-3v3h-2z" /></svg>
                        ${option._layer.params.cropLabel ?  html`<span class="cl-po--crop-label">${option._layer.params.cropLabel}</span>` : null}
                    </label>
                `: null}
            </div>
            <progress class="cl-po--preview-progress" style="display:none;"></progress>
            <div class="cl-po--upload-files">
             ${repeat(option._controller.files, (file) => html`
                   <div>${file.name} <span class="cl-po--remove" @click=${(e) => option._controller.remove(option, config.productForm, file, onChange)}>&times;</span></div>
             `)}
            </div>
            
            ${option.value && option._layer && option._layer.params.layerEditor ?  html`${TemplateRegistry.templates['layer_editor'](option, config, onChange)}`: null}
        </div>
    `;
}